import React, { Suspense, useCallback, useEffect } from 'react'
import LanguageContext from '../../contexts/languageContext'
import PageContext from '../../contexts/pageContext'
import VersionContext from '../../contexts/versionContext'
import usePage from '../../hooks/usePage'
import useLanguage from '../../hooks/useLanguage'
import useVersion from '../../hooks/useVersion'
import useSearch from '../../hooks/useSearch'
import Sidebar from '../../components/Sidebar'
import * as ScrollHelpers from '../../helpers/scroll'
import SearchContextProvider, { SearchContext } from '../../contexts/searchContext'

const PageContainer = ({ children }) => {
  const page = usePage(PageContext.Consumer.page)
  const language = useLanguage(LanguageContext.Consumer.lang)
  const version = useVersion(VersionContext.Consumer.version)
  const search = useSearch(SearchContext)

  const onScrollPositonToBackState = useCallback(({ currentTarget }) => {
    const { location } = currentTarget
    const scrollPositionFromSessionStorage = ScrollHelpers.getScrollPositionBySessionStorage(location)

    ScrollHelpers.scrollToLastPositionOnPage(scrollPositionFromSessionStorage)
  }, [])

  useEffect(() => {
    window.addEventListener('popstate', onScrollPositonToBackState)

    return () => window.removeEventListener('popstate', onScrollPositonToBackState)
  }, [onScrollPositonToBackState])

  return (
    <Suspense fallback="loading...">
      <PageContext.Provider value={page}>
        <LanguageContext.Provider value={language}>
          <SearchContextProvider value={search}>
            <VersionContext.Provider value={version}>{children}</VersionContext.Provider>
            <Sidebar />
          </SearchContextProvider>
        </LanguageContext.Provider>
      </PageContext.Provider>
    </Suspense>
  )
}

export default PageContainer
